import styled, { css } from 'styled-components';
import { Flex, FlexColumn } from '../Flex';

export const ListContainer = styled(FlexColumn)`${({ theme }) => `
  gap:${theme.padding[2]};
`}`;

export const ListTitleBar = styled(Flex)`
  justify-content:space-between;
  align-items:center;
  width:100%;
`;

export const ListInfoContainer = styled(FlexColumn)<{ isHeading?: boolean, isFirstChild?: boolean, isSelected?: boolean, isLastChild?: boolean, hasErrors?: boolean }>`${({
  theme, isHeading, isFirstChild, isSelected, isLastChild, hasErrors,
}) => {
  const getWidth = () => {
    if (isHeading) return '128px';
    if (isLastChild) return '155px';
    return 'max-content';
  };

  const getBackground = () => {
    if (isFirstChild && isSelected && hasErrors) return theme.colours.danger[3];
    if (isSelected) return theme.colours.primary[10];
    if (isFirstChild && !isSelected) return theme.colours.primary[8];
    if (isLastChild) return theme.primary;
    return '';
  };

  return `
    justify-content:center;
    padding:${isHeading && isFirstChild ? theme.padding[4] : theme.padding[2]};
    width:${getWidth()};
    background:${getBackground()};
  `;
}}`;

export const listHeaderCss = css`${({ theme }) => `
  background: ${theme.colours.neutral[9]};
`}`;
